export enum SpanName {
  TRACK_ANALYTICS_BING_ADS = 'track_analytics_bing_ads',
  TRACK_ANALYTICS_FACEBOOK = 'track_analytics_facebook',
  TRACK_ANALYTICS_PINTEREST = 'track_analytics_pinterest',
  TRACK_ANALYTICS_GTM = 'track_analytics_gtm',
  TRACK_ANALYTICS_TIK_TOK = 'track_analytics_tik_tok',
  TRACK_ANALYTICS_AMPLITUDE = 'track_analytics_amplitude',
  TRACK_ANALYTICS_BACK_END = 'track_analytics_back_end',
  GET_LTV_PREDICT = 'get_ltv_predict',
  SIGN_IN_BY_TOKEN = 'sign_in_by_token',
  RECURRING_PAYMENT_REQUEST = 'recurring_payment_request',
  CREATE_ASKNEBULA_ACCOUNT = 'create_asknebula_account',
  PAYMENT_SUCCEED = 'payment_succeed',
  CREATE_ORDER_FROM_EMAIL_UPSELLS = 'create_order_from_email_upsells',
  CREATE_ORDER = 'create_order',
  INITIALIZE_FORM_REQUEST = 'initialize_form_request',
  SCREEN_OPENED = 'screen_opened',
  SCREEN_CLICKED = 'screen_clicked',
  INITIALIZE_RESIGN_FORM = 'initialize_resign_form',
  TRACK_WEB_VITALS = 'track_web_vitals',
  SIGN_IN = 'sign_in',
  TRACK_ANALYTICS_GOOGLE_4 = 'track_analytics_google_4',
  TRACK_ANALYTICS_GOOGLE = 'track_analytics_google',
  SIGN_UP_VIA_GOOGLE = 'sign_up_via_google',
  SIGN_UP_VIA_FACEBOOK = 'sign_up_via_facebook',
  SIGN_UP_VIA_QUIZ = 'sign_up_via_quiz',
  TRACK_ANALYTICS_EVERFLOW_ATTRIBUTION_PARAMETERS = 'track_analytics_everflow_attribution_parameters',
}
